import { createApiRequest } from "@/lib/api/createApiService";
import { BILL_OCR_ENDPOINTS } from "./bill-ocr.endpoints";

export const billOcrService = {
  extract: (file) => {
    const body = new FormData();
    body.append("file", file);
    return createApiRequest({
      url: BILL_OCR_ENDPOINTS.EXTRACT,
      method: "POST",
      body,
      isFormData: true,
    });
  },

  sendToNxmap: (extraction) =>
    createApiRequest({
      url: BILL_OCR_ENDPOINTS.SEND_TO_NXMAP,
      method: "POST",
      body: { extraction },
    }),
};
